import { IFilter, InitializeFilterDropdown } from "../../../shared/scripts/dropdown-functions";

import { plainToClass } from "class-transformer";
import { TableColumnVisibilityController, TableColumnGroup } from "../../../shared/scripts/table-column-visibility";
import { ResourcesMembershipEntity } from "./resources-membership.entities";
import { DocumentLibraryLoaderWithSharepoint } from "../../../shared/components/document-library/document-library-loader";



export class ResourcesMembershipPage implements IFilter {

    users: ResourcesMembershipEntity[];
    visibleUserEmails: string;
    dataTable: any;
    tableColumnController: TableColumnVisibilityController;
    documentLibraryLoader: DocumentLibraryLoaderWithSharepoint;


    constructor(userJson: any, modelJson: any, isCollab: boolean, requiredDialogId: string = "", targetFile: string = "", targetSearchBox: string = "", userExpertise: string = "", userDataJson: any) {
        $(() => {
            const expertiseField = document.getElementById('expertise-input') as HTMLInputElement;
            if (userExpertise.includes("&quot;")) userExpertise = userExpertise.replace(/&quot;/g, '');
            expertiseField.value = userExpertise;
            const expertiseUsers = plainToClass(ResourcesMembershipEntity, <ResourcesMembershipEntity[]>userDataJson);
            //create a dictionary of user email to expertise
            const expertiseDict: { [key: string]: string } = {};
            expertiseUsers.forEach((user: ResourcesMembershipEntity) => {
                expertiseDict[user.Email.toLowerCase()] = user.Expertise;
            });
            this.users = plainToClass(ResourcesMembershipEntity, <ResourcesMembershipEntity[]>userJson);
            this.users = this.users.map((user: ResourcesMembershipEntity) => {
                user.initialize();
                const expertise = expertiseDict[user.Email.toLowerCase()] || "";
                user.Expertise = expertise;
                if (expertise.length > 2) {
                    user.Expertise = expertise.slice(1, -1);
                }
                
                return user;
            });

            this.documentLibraryLoader = new DocumentLibraryLoaderWithSharepoint(modelJson, isCollab, requiredDialogId, targetFile, targetSearchBox);

            this.initializeTable();

            //triggers the redraw to account due to column with icon. will see a slight "popping" if looking carefully            
            setTimeout(() => {
                $("#user-directory-table").DataTable().columns.adjust().draw();
            }, 1);
        });
    }


    openExpertiseModal(): void {
        $('#expertiseModal').modal('show');
    }

    finishExpertiseUpdate(): void {
        document.getElementsByClassName("document-library-page")[0].remove();
        document.getElementById("start-members").style.display = "none";
        $('#expertiseModal').modal('hide');
        document.getElementById("spinner").classList.remove("d-none");
        setTimeout(() => window.location.href = "/secure/collaboration/resources", 5000);
    }


    saveExpertiseAndClose(onSuccessFn: Function = (response: any) => { console.log("success"); this.finishExpertiseUpdate(); }, onErrorFn: Function = (response: any) => { console.log(response); }): void {
        const expertiseInput = document.getElementById('expertise-input') as HTMLInputElement;
        const expertise = expertiseInput.value;
        $.ajax({
            url: '/secure/collaboration/resources?handler=SaveExpertise',
            method: "POST",
            //dataType: "json",
            //contentType: "application/json",
            data: { expertise: JSON.stringify(expertise) },
            headers: {
                "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() as string
            },
            success: (response) => {
                onSuccessFn(response);
            },
            error: (response) => {
                onErrorFn(response);
            }
        });
    }

    initializeTable(): void {
        this.dataTable = $('#user-directory-table').DataTable({
            "dom": '<"top-controls"<"search-bar"f><"expertise-btn"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            columns: [
                { data: { _: "DisplayEmail", sort: "Email" }, title: "Email", className: "email text-left font-size12" },
                { data: { _: "DisplayName", sort: "SortName" }, title: "Name", className: "name text-left font-size12" },
                { data: "Expertise", title: "Expertise", className: "expertise text-left font-size12" },
                { data: "Role", title: "Role", className: "role text-left font-size12" },
                { data: "ResearchHub", title: "CONNECT Affiliation", className: "affiliation text-left font-size12" },
                { data: "Institution", title: "Institution", className: "institution text-left font-size12" },
                //{ data: "ExpertisePastRoles", title: "<span class='nowrap'>Prior Research Role</span>", className: "research text-left font-size12" },
                //{ data: "ExpertiseAsud", title: "<span class='nowrap'>ASUD Expertise</span>", className: "disorder text-left font-size12" },
                //{ data: "ExpertisePsych", title: "<span class='nowrap'>Psychological Comorbidity Expertise</span>", className: "disorder text-left font-size12" },
                //{ data: "ExpertiseClinical", title: "<span class='nowrap'>Clinical Expertise</span>", className: "disorder text-left font-size12" },
                //{ data: "ExpertiseRegulatory", title: "<span class='nowrap'>Regulatory Expertise</span>", className: "specialized text-left font-size12" },
                //{ data: "ExpertiseDesign", title: "<span class='nowrap'>Study Design and Analysis Expertise</span>", className: "specialized text-left font-size12" },
                //{ data: "ExpertisePopulation", title: "<span class='nowrap'>Military and Veteran Populations Expertise</span>", className: "specialized text-left font-size12" },
            ],
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',

                },
                {
                    text: '<i class="fas fa-envelope"></i>',
                    titleAttr: 'Send Email',
                    action: (e, dt, node, config) => {
                        navigator.clipboard.writeText(this.visibleUserEmails).then(
                            () => {
                                $('#directory-email-modal').modal('show');
                                $('#modal-email-list').text(this.visibleUserEmails);
                            });
                    }
                }
            ],
            data: this.users,
            initComplete: (settings, json) => { }
        });

        $(".top-controls").addClass('row mx-0');

       

        $(".search-bar").addClass('col-12 col-md-3 pl-0');
        $(".count-found").addClass('col-12 col-md-6 d-flex justify-content-end vertical-align-middle align-self-end mt-2 ml-auto');

        $(".count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"people-found-count\"></span></div>');
        $(".count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        $(".expertise-btn").empty().html('<div id="expertise-button" style="margin-top: 18px;"><button class="btn btn-outline-primary no-focus font-size11" style="height: 34px;" onclick="page.openExpertiseModal()"><i class="fas fa-plus"></i>Add Expertise</button></div>');


        $('#user-directory-table').on('search.dt', (e, settings) => {
            this.createEmailList(this.dataTable.rows({ search: 'applied' }).data());
            this.setPeopleFoundLabel(this.dataTable.rows({ search: 'applied' }).count());
        });
        this.createEmailList(this.users);
        this.setPeopleFoundLabel(this.users.length);
    }

    createEmailList(matchingUsers: ResourcesMembershipEntity[]): void {
        this.visibleUserEmails = matchingUsers.map((user: ResourcesMembershipEntity) => user.Email).join("; ");
    }

    setPeopleFoundLabel(count: number): void {

        switch (count) {
            case 0: $('#people-found-count').text("Nobody Found"); break;
            case 1: $('#people-found-count').text("1 Person Found"); break;
            default: $('#people-found-count').text(count + " People Found");
        }
    }

    triggerFilter(): void {

        //let matchingUsers: UserDirectoryEntity[] = [];

        //let userMatches: boolean;
        //this.users.forEach((user: UserDirectoryEntity) => {

        //    userMatches = true; //must match all filters

        //    //this.filterDropdownIds = ['#pasarole-dropdown', '#institution-dropdown', '#study-dropdown', '#studytype-dropdown', '#pastrole-dropdown', '#asud-dropdown', '#psych-dropdown', '#clinical-dropdown', '#reg-dropdown', '#design-dropdown', '#pop-dropdown'];

        //    if (!user.matchesFilter(this.getSelectedDropdownValues('#pasarole-dropdown'), this.getSelectedDropdownValues('#institution-dropdown'), this.getSelectedDropdownValues('#study-dropdown'),
        //        this.getSelectedDropdownValues('#studytype-dropdown'), this.getSelectedDropdownValues('#pastrole-dropdown'), this.getSelectedDropdownValues('#asud-dropdown'),
        //        this.getSelectedDropdownValues('#psych-dropdown'), this.getSelectedDropdownValues('#clinical-dropdown'), this.getSelectedDropdownValues('#reg-dropdown'),
        //        this.getSelectedDropdownValues('#design-dropdown'), this.getSelectedDropdownValues('#pop-dropdown'))) {
        //        userMatches = false;
        //    }

        //    if (userMatches) { matchingUsers.push(user); }
        //});

        //this.updateTable(matchingUsers);
    }
}